module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8c3127887a7aacaea989aa247e510f84.jpg";